"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const i = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8M21 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-4 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
        clipRule: "evenodd"
      }
    )
  }
), d = l(i);
export {
  d as ShopCategoriesFilled,
  d as default
};
